export default __webpack_public_path__ + "static/media/image-header.b91dc87c.svg";